import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
	Box,
	Typography,
	Button,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Checkbox,
	FormControlLabel,
	Link,
	IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppLayout from "../../components/AppLayout";
import { EntradaProdutoService } from "../../service/entrada_produto_service";
import { FornecedorService } from "../../service/fornecedor_service";
import ModalClassificarQualidade from "../../components/ModalClassificarQualidade";
import { hojeISO } from "../../utils/dateUtils";

function EntradaProdutosCad() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [salvando, setSalvando] = useState(false);
	const [modalQualidadeOpen, setModalQualidadeOpen] = useState(false);

	const unidadeDistribuidoraId = localStorage.getItem("selected_unidade_id");

	const [formData, setFormData] = useState({
		produtoUnidadeDistribuidoraId: "",
		cultivoId: "",
		unidadeMedidaId: "",
		embalagemId: "",
		data: hojeISO(),
		fornecedorId: "",
		codigoRastreio: "",
		notaFiscalRecibo: "",
		numeroPedido: "",
		quantidade: "",
		numeroCaixas: "",
		preco: "",
		recebimentoConfirmado: false,
	});

	const [produtorForaDaBase, setProdutorForaDaBase] = useState(false);

	const [fornecedorNovo, setFornecedorNovo] = useState({
		nome: "",
		nomeFantasia: "",
		email: "",
		telefone: "",
		cpfCnpj: "",
	});

	const [qualidades, setQualidades] = useState([]);
	const [produtos, setProdutos] = useState([]);
	const [fornecedores, setFornecedores] = useState([]);
	const [todosFornecedores, setTodosFornecedores] = useState([]);
	const [qualidadesDisponiveis, setQualidadesDisponiveis] = useState([]);

	const entradaProdutoService = new EntradaProdutoService();
	const fornecedorService = new FornecedorService();

	useEffect(() => {
		loadDadosIniciais();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const loadDadosIniciais = async () => {
		setLoading(true);
		try {
			const produtosData = await entradaProdutoService.getProdutosEntrada(unidadeDistribuidoraId);
			const fornecedoresData = await fornecedorService.getAll(unidadeDistribuidoraId, 1, 1000);
			const qualidadesData = await entradaProdutoService.getQualidades();

			setProdutos(produtosData || []);
			setTodosFornecedores(fornecedoresData?.data || []);
			setFornecedores(fornecedoresData?.data || []);
			setQualidadesDisponiveis(qualidadesData || []);

			if (id) {
				await loadEntrada(id, produtosData || []);
			}
		} catch (error) {
			console.error("Erro ao carregar dados iniciais:", error);
			alert(error.message || "Erro ao carregar dados iniciais");
		} finally {
			setLoading(false);
		}
	};

	const loadEntrada = async (entradaId, produtosData) => {
		try {
			const data = await entradaProdutoService.getById(entradaId);

			const produto = produtosData.find((p) => p.id === data.produtoUnidadeDistribuidoraId);

			setFormData({
				produtoUnidadeDistribuidoraId: data.produtoUnidadeDistribuidoraId || "",
				cultivoId: produto?.cultivoId || "",
				unidadeMedidaId: data.unidadeMedidaId || "",
				embalagemId: data.embalagemId || "",
				data: data.data ? data.data.split("T")[0] : "",
				fornecedorId: data.fornecedorId || "",
				codigoRastreio: data.codigoRastreio || "",
				notaFiscalRecibo: data.notaFiscalRecibo || "",
				numeroPedido: data.numeroPedido || "",
				quantidade: data.quantidade || "",
				numeroCaixas: data.numeroCaixas || "",
				preco: data.preco || "",
				recebimentoConfirmado: data.recebimentoConfirmado || false,
			});

			if (produto?.cultivoId) {
				try {
					const fornecedoresFiltrados = await entradaProdutoService.getFornecedoresPorProduto(
						unidadeDistribuidoraId,
						produto.cultivoId,
					);
					setFornecedores(fornecedoresFiltrados || []);
				} catch (error) {
					console.error("Erro ao buscar fornecedores:", error);
					setFornecedores(todosFornecedores);
				}
			}

			if (data.qualidades && data.qualidades.length > 0) {
				setQualidades(
					data.qualidades.map((q) => ({
						qualidadeColheitaId: q.qualidadeColheitaId,
						quantidade: q.quantidade,
					}))
				);
			}
		} catch (error) {
			console.error("Erro ao carregar entrada:", error);
			alert(error.message || "Erro ao carregar entrada");
		}
	};

	const handleProdutoChange = async (produtoId) => {
		const produto = produtos.find((p) => p.id === produtoId);

		setFormData({
			...formData,
			produtoUnidadeDistribuidoraId: produtoId || "",
			cultivoId: produto?.cultivoId || "",
			unidadeMedidaId: "",
			embalagemId: "",
			fornecedorId: "",
		});

		if (produtoId) {
			try {
				const fornecedoresFiltrados = await entradaProdutoService.getFornecedoresPorProduto(
					unidadeDistribuidoraId,
					produto?.cultivoId,
				);
				setFornecedores(fornecedoresFiltrados || []);
			} catch (error) {
				console.error("Erro ao buscar fornecedores:", error);
				setFornecedores(todosFornecedores);
			}
		} else {
			setFornecedores(todosFornecedores);
		}
	};

	const handleEmbalagemChange = (embalagemId) => {
		const produto = produtos.find((p) => p.id === formData.produtoUnidadeDistribuidoraId);
		const embalagem = produto?.embalagens?.find((e) => e.id === embalagemId);
		const qtd = parseFloat(formData.quantidade) || 0;
		const numeroCaixas = embalagem?.quantidade > 0 && qtd > 0
			? Math.ceil(qtd / embalagem.quantidade)
			: "";
		setFormData({
			...formData,
			embalagemId: embalagemId || "",
			unidadeMedidaId: embalagem?.unidadeMedidaId || "",
			numeroCaixas: numeroCaixas !== "" ? String(numeroCaixas) : "",
		});
	};

	const handleSalvarQualidades = (qualidadesRecebidas) => {
		if (qualidadesRecebidas) {
			setQualidades(qualidadesRecebidas);
		} else if (id) {
			loadEntrada(id, produtos);
		}
		setModalQualidadeOpen(false);
	};

	const handleSalvar = async () => {
		try {
			if (!formData.produtoUnidadeDistribuidoraId) {
				alert("Selecione um produto");
				return;
			}
			if (!formData.embalagemId) {
				alert("Selecione uma embalagem");
				return;
			}
			if (!formData.unidadeMedidaId) {
				alert("A embalagem selecionada não possui unidade de medida");
				return;
			}
			if (!formData.data) {
				alert("Informe a data");
				return;
			}
			if (!produtorForaDaBase && !formData.fornecedorId) {
				alert("Selecione um fornecedor");
				return;
			}
			if (produtorForaDaBase) {
				if (!fornecedorNovo.nome || !fornecedorNovo.cpfCnpj) {
					alert("Preencha os campos obrigatórios do fornecedor: Nome e CPF/CNPJ");
					return;
				}
			}
			if (!formData.quantidade || parseFloat(formData.quantidade) <= 0) {
				alert("Informe a quantidade");
				return;
			}
			if (!formData.preco || parseFloat(formData.preco) <= 0) {
				alert("Informe o preço");
				return;
			}

			setSalvando(true);

			const qualidadesFormatadas = qualidades.length > 0
				? qualidades.map(q => ({
					qualidadeColheitaId: q.qualidadeColheitaId,
					quantidade: parseFloat(q.quantidade)
				}))
				: undefined;

			const payload = {
				id: id || undefined,
				unidadeDistribuidoraId,
				produtoUnidadeDistribuidoraId: formData.produtoUnidadeDistribuidoraId,
				unidadeMedidaId: formData.unidadeMedidaId,
				embalagemId: formData.embalagemId || undefined,
				data: formData.data,
				fornecedorId: produtorForaDaBase ? undefined : formData.fornecedorId,
				codigoRastreio: formData.codigoRastreio || undefined,
				notaFiscalRecibo: formData.notaFiscalRecibo || undefined,
				numeroPedido: formData.numeroPedido || undefined,
				quantidade: parseFloat(formData.quantidade),
				numeroCaixas: formData.numeroCaixas ? parseInt(formData.numeroCaixas) : undefined,
				preco: parseFloat(formData.preco),
				recebimentoConfirmado: formData.recebimentoConfirmado,
				qualidades: qualidadesFormatadas,
				produtorForaDaBase: produtorForaDaBase,
				fornecedorNovo: produtorForaDaBase ? fornecedorNovo : undefined,
			};

			if (id) {
				await entradaProdutoService.update(payload);
				alert("Entrada atualizada com sucesso!");
			} else {
				await entradaProdutoService.save(payload);
				alert("Entrada cadastrada com sucesso!");
			}

			navigate("/compras");
		} catch (error) {
			console.error("Erro ao salvar entrada:", error);
			alert(error.message || "Erro ao salvar entrada");
		} finally {
			setSalvando(false);
		}
	};

	if (loading) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					minHeight: "100vh",
				}}
			>
				<Typography>Carregando...</Typography>
			</Box>
		);
	}

	// Embalagens do produto selecionado
	const produtoSelecionado = produtos.find((p) => p.id === formData.produtoUnidadeDistribuidoraId);
	const embalagensDoProduto = produtoSelecionado?.embalagens || [];

	// Unidade de medida derivada da embalagem selecionada
	const embalagemSelecionada = embalagensDoProduto.find((e) => e.id === formData.embalagemId);
	const unidadeSigla = embalagemSelecionada?.unidadeMedida?.sigla || "";

	// Mock entrada para o modal
	const entradaMock = {
		id: id || undefined,
		produtoUnidadeDistribuidora: produtoSelecionado,
		quantidade: formData.quantidade,
		qualidades: qualidades.map((q) => ({
			qualidadeColheitaId: q.qualidadeColheitaId,
			quantidade: q.quantidade,
			qualidadeColheita: qualidadesDisponiveis.find((qd) => qd.id === q.qualidadeColheitaId),
		})),
	};

	return (
		<AppLayout currentPage="compras">
			<Box sx={{ maxWidth: 1400, mx: "auto" }}>
				<Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}>
					<IconButton onClick={() => navigate("/compras")} sx={{ color: "#666" }}>
						<ArrowBackIcon />
					</IconButton>
					<Typography
						variant="h5"
						sx={{
							color: "#666",
							fontWeight: 500,
							fontSize: "20px",
						}}
					>
						{id ? "Editar Entrada de Produto" : "Nova Entrada de Produto"}
					</Typography>
				</Box>

				<Box
					sx={{
						bgcolor: "white",
						borderRadius: "4px",
						boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
						overflow: "hidden",
					}}
				>
						<Box sx={{ px: 6, py: 4 }}>
							{/* Linha 1: Título */}
							<Typography
								variant="subtitle1"
								sx={{ color: "#1a9e8f", fontWeight: 600, mb: 2, fontSize: "16px" }}
							>
								Dados do Produto
							</Typography>

							{/* Linha 2: Produto (25%) + Embalagem (25%) + Data (15%) + Fornecedor (25%) + Checkbox (10%) */}
							<Box sx={{ display: "flex", gap: 2, mb: 3, alignItems: "flex-start" }}>
								<Box sx={{ flex: "0 0 calc(25% - 12px)" }}>
									<FormControl fullWidth required>
										<InputLabel style={{ fontSize: "15px" }}>Produto</InputLabel>
										<Select
											value={formData.produtoUnidadeDistribuidoraId}
											onChange={(e) => handleProdutoChange(e.target.value)}
											label="Produto"
											style={{ fontSize: "15px" }}
										>
											{produtos.map((produto) => (
												<MenuItem key={produto.id} value={produto.id} style={{ fontSize: "15px" }}>
													{produto.cultivo?.cultura || ""}
													{produto.cultivo?.variedade ? ` - ${produto.cultivo.variedade}` : ""}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Box>

								<Box sx={{ flex: "0 0 calc(25% - 12px)" }}>
									<FormControl fullWidth required disabled={!formData.produtoUnidadeDistribuidoraId}>
										<InputLabel style={{ fontSize: "15px" }}>Embalagem</InputLabel>
										<Select
											value={formData.embalagemId}
											onChange={(e) => handleEmbalagemChange(e.target.value)}
											label="Embalagem"
											style={{ fontSize: "15px" }}
										>
											{embalagensDoProduto.map((embalagem) => (
												<MenuItem key={embalagem.id} value={embalagem.id} style={{ fontSize: "15px" }}>
													{embalagem.descricao}
													{embalagem.quantidade > 0
														? ` (${embalagem.quantidade}${embalagem.unidadeMedida ? embalagem.unidadeMedida.sigla : ""})`
														: embalagem.unidadeMedida ? ` (${embalagem.unidadeMedida.sigla})` : ""}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Box>

								<Box sx={{ flex: "0 0 calc(15% - 12px)" }}>
									<TextField
										fullWidth
										required
										label="Data"
										type="date"
										value={formData.data}
										onChange={(e) => setFormData({ ...formData, data: e.target.value })}
										InputLabelProps={{ style: { fontSize: "15px" }, shrink: true }}
										inputProps={{ style: { fontSize: "15px" } }}
									/>
								</Box>

								<Box sx={{ flex: "0 0 calc(25% - 12px)" }}>
									<FormControl fullWidth required={!produtorForaDaBase}>
										<InputLabel style={{ fontSize: "15px" }}>Fornecedor</InputLabel>
										<Select
											value={formData.fornecedorId}
											onChange={(e) => setFormData({ ...formData, fornecedorId: e.target.value })}
											label="Fornecedor"
											style={{ fontSize: "15px" }}
											disabled={produtorForaDaBase}
										>
											{fornecedores.map((fornecedor) => (
												<MenuItem key={fornecedor.id} value={fornecedor.id} style={{ fontSize: "15px" }}>
													{fornecedor.nome}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Box>

								<Box sx={{ flex: "0 0 calc(10% - 12px)", display: "flex", alignItems: "center", pt: 1 }}>
									<FormControlLabel
										control={
											<Checkbox
												checked={produtorForaDaBase}
												onChange={(e) => setProdutorForaDaBase(e.target.checked)}
												disabled={!!id}
											/>
										}
										label={
											<Typography style={{ fontSize: "14px", color: "#555" }}>
												Produtor fora da base
											</Typography>
										}
									/>
								</Box>
							</Box>

							{/* Linha 3: Campos do novo fornecedor (condicional) */}
							{produtorForaDaBase && (
								<Box sx={{ display: "flex", gap: 2, mb: 3 }}>
									<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
										<TextField
											fullWidth
											required
											label="Razão Social / Nome"
											value={fornecedorNovo.nome}
											onChange={(e) =>
												setFornecedorNovo({ ...fornecedorNovo, nome: e.target.value })
											}
											InputLabelProps={{ style: { fontSize: "15px" } }}
											inputProps={{ style: { fontSize: "15px" } }}
										/>
									</Box>
									<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
										<TextField
											fullWidth
											label="Nome Fantasia"
											value={fornecedorNovo.nomeFantasia}
											onChange={(e) =>
												setFornecedorNovo({ ...fornecedorNovo, nomeFantasia: e.target.value })
											}
											InputLabelProps={{ style: { fontSize: "15px" } }}
											inputProps={{ style: { fontSize: "15px" } }}
										/>
									</Box>
									<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
										<TextField
											fullWidth
											label="Telefone"
											value={fornecedorNovo.telefone}
											onChange={(e) =>
												setFornecedorNovo({ ...fornecedorNovo, telefone: e.target.value })
											}
											InputLabelProps={{ style: { fontSize: "15px" } }}
											inputProps={{ style: { fontSize: "15px" } }}
										/>
									</Box>
									<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
										<TextField
											fullWidth
											label="E-mail"
											type="email"
											value={fornecedorNovo.email}
											onChange={(e) =>
												setFornecedorNovo({ ...fornecedorNovo, email: e.target.value })
											}
											InputLabelProps={{ style: { fontSize: "15px" } }}
											inputProps={{ style: { fontSize: "15px" } }}
										/>
									</Box>
									<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
										<TextField
											fullWidth
											required
											label="CPF / CNPJ"
											value={fornecedorNovo.cpfCnpj}
											onChange={(e) =>
												setFornecedorNovo({ ...fornecedorNovo, cpfCnpj: e.target.value })
											}
											InputLabelProps={{ style: { fontSize: "15px" } }}
											inputProps={{ style: { fontSize: "15px" } }}
										/>
									</Box>
								</Box>
							)}

							{/* Linha 4: Código Rastreio + NF + Quantidade + Nº Embalagens + Preço */}
							<Box sx={{ display: "flex", gap: 2, mb: 3 }}>
								<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
									<TextField
										fullWidth
										label="Código de Rastreio"
										value={formData.codigoRastreio}
										onChange={(e) => setFormData({ ...formData, codigoRastreio: e.target.value })}
										InputLabelProps={{ style: { fontSize: "15px" } }}
										inputProps={{ style: { fontSize: "15px" } }}
									/>
								</Box>

								<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
									<TextField
										fullWidth
										label="Nota Fiscal / Recibo"
										value={formData.notaFiscalRecibo}
										onChange={(e) => setFormData({ ...formData, notaFiscalRecibo: e.target.value })}
										InputLabelProps={{ style: { fontSize: "15px" } }}
										inputProps={{ style: { fontSize: "15px" } }}
									/>
								</Box>

								<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
									<TextField
										fullWidth
										required
										label={`Quantidade${unidadeSigla ? ` (${unidadeSigla})` : ""}`}
										type="number"
										value={formData.quantidade}
										onChange={(e) => {
											const novaQtd = e.target.value;
											const embalagem = embalagensDoProduto.find((em) => em.id === formData.embalagemId);
											const qtdNum = parseFloat(novaQtd) || 0;
											const numeroCaixas = embalagem?.quantidade > 0 && qtdNum > 0
												? String(Math.ceil(qtdNum / embalagem.quantidade))
												: "";
											setFormData({ ...formData, quantidade: novaQtd, numeroCaixas });
										}}
										InputLabelProps={{ style: { fontSize: "15px" } }}
										inputProps={{ style: { fontSize: "15px" }, min: 0, step: 0.01 }}
									/>
								</Box>

								<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
									<TextField
										fullWidth
										label="Número de Embalagens"
										type="number"
										value={formData.numeroCaixas}
										InputLabelProps={{ style: { fontSize: "15px" }, shrink: !!formData.numeroCaixas }}
										inputProps={{ style: { fontSize: "15px", color: "#555" }, readOnly: true }}
										sx={{ "& .MuiOutlinedInput-root": { bgcolor: "#f5f5f5" } }}
									/>
								</Box>

								<Box sx={{ flex: "0 0 calc(20% - 12px)" }}>
									<TextField
										fullWidth
										required
										label={`Preço por ${unidadeSigla || "unidade"} (R$)`}
										type="number"
										value={formData.preco}
										onChange={(e) => setFormData({ ...formData, preco: e.target.value })}
										InputLabelProps={{ style: { fontSize: "15px" } }}
										inputProps={{ style: { fontSize: "15px" }, min: 0, step: 0.01 }}
									/>
								</Box>
							</Box>

							{/* Resumo detalhado da entrada */}
							{formData.quantidade && formData.preco && (() => {
								const qtd = parseFloat(formData.quantidade);
								const numEmbalagens = formData.numeroCaixas ? parseInt(formData.numeroCaixas) : 0;
								const precoPorUnidade = parseFloat(formData.preco);
								const valorTotal = precoPorUnidade * qtd;
								const unidade = unidadeSigla || "un";
								const qtdPorEmbalagem = numEmbalagens > 0 ? (qtd / numEmbalagens) : 0;

								return (
									<Box
										sx={{
											border: "1px solid #e0e0e0",
											borderRadius: "6px",
											bgcolor: "#f9fafb",
											px: 4,
											py: 2.5,
											mb: 3,
											display: "flex",
											justifyContent: "space-around",
											alignItems: "center",
											gap: 4,
										}}
									>
										{numEmbalagens > 0 && (
											<>
												<Box sx={{ textAlign: "center" }}>
													<Typography sx={{ fontSize: "12px", color: "#888", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mb: 0.5 }}>
														Detalhamento de Embalagens
													</Typography>
													<Typography sx={{ fontSize: "16px", color: "#333", fontWeight: 600 }}>
														{numEmbalagens} {numEmbalagens === 1 ? "embalagem" : "embalagens"} de {qtdPorEmbalagem.toFixed(2).replace(".", ",")} {unidade}
													</Typography>
												</Box>

												<Box sx={{ width: "1px", height: "40px", bgcolor: "#e0e0e0" }} />
											</>
										)}

										<Box sx={{ textAlign: "center" }}>
											<Typography sx={{ fontSize: "12px", color: "#888", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mb: 0.5 }}>
												Preço por {unidade}
											</Typography>
											<Typography sx={{ fontSize: "16px", color: "#333", fontWeight: 600 }}>
												R$ {precoPorUnidade.toFixed(2).replace(".", ",")} / {unidade}
											</Typography>
										</Box>

										<Box sx={{ width: "1px", height: "40px", bgcolor: "#e0e0e0" }} />

										<Box sx={{ textAlign: "center" }}>
											<Typography sx={{ fontSize: "12px", color: "#888", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px", mb: 0.5 }}>
												Valor Total
											</Typography>
											<Typography sx={{ fontSize: "16px", color: "#1a9e8f", fontWeight: 700 }}>
												R$ {valorTotal.toFixed(2).replace(".", ",")}
											</Typography>
										</Box>
									</Box>
								);
							})()}

							{/* Link para especificar qualidade */}
							<Box sx={{ textAlign: "center", mt: 6, mb: 4 }}>
								<Link
									component="button"
									variant="body2"
									onClick={() => setModalQualidadeOpen(true)}
									sx={{
										fontSize: "17px",
										fontWeight: 700,
										color: "#1a9e8f",
										textDecoration: "none",
										cursor: "pointer",
										"&:hover": {
											textDecoration: "underline",
										},
									}}
								>
									Especificar qualidade do produto
									{qualidades.length > 0 && ` (${qualidades.length} qualidade(s) especificada(s))`}
								</Link>
							</Box>
						</Box>

						{/* Rodapé com checkbox e botão */}
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								px: 6,
								pb: 4,
								pt: 0,
							}}
						>
							<FormControlLabel
								control={
									<Checkbox
										checked={formData.recebimentoConfirmado}
										onChange={(e) =>
											setFormData({ ...formData, recebimentoConfirmado: e.target.checked })
										}
									/>
								}
								label={
									<Typography style={{ fontSize: "15px", color: "#555" }}>
										Recebimento confirmado (vai direto para o consolidado)
									</Typography>
								}
							/>

							<Button
								variant="contained"
								onClick={handleSalvar}
								disabled={salvando}
								sx={{
									bgcolor: "#1a9e8f",
									"&:hover": {
										bgcolor: "#138a7d",
										boxShadow: "0 2px 6px rgba(23, 162, 184, 0.4)",
									},
									"&:disabled": {
										bgcolor: "#ccc",
									},
									textTransform: "none",
									px: 5,
									py: 1.5,
									fontSize: "15px",
									fontWeight: 500,
									borderRadius: "4px",
									boxShadow: "none",
								}}
							>
								{salvando ? "Salvando..." : id ? "Atualizar" : "Cadastrar"}
							</Button>
					</Box>
				</Box>
			</Box>

			{/* Modal de Qualidade */}
			<ModalClassificarQualidade
				open={modalQualidadeOpen}
				onClose={() => setModalQualidadeOpen(false)}
				entrada={entradaMock}
				onSave={handleSalvarQualidades}
			/>
		</AppLayout>
	);
}

export default EntradaProdutosCad;
